import { render, staticRenderFns } from "./borrowBooks.vue?vue&type=template&id=1b69bef5&"
import script from "./borrowBooks.vue?vue&type=script&lang=js&"
export * from "./borrowBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports